import { GlobalProvider } from './context/GlobalProvider';
import Pages from './pages/Pages';

function App() {

    return (
        <GlobalProvider>
            <Pages />
        </GlobalProvider>
    );
}

export default App;